<lib-navigation-header
  [routesAndNames]="routesAndNames"
></lib-navigation-header>
<div class="overlay">
  <lib-highchart-container [chartOptions]="chartOptions">
  </lib-highchart-container>
</div>
<div class="main">
  <router-outlet></router-outlet>
</div>
